import React from 'react';
import BarSplitChart from './BarSplitChart';

// Presentation-only: merge the "Freight on Board" (FOB) and "Inclusive" (IN)
// delivery-term codes into a single combined bar. The summed count flows into
// BarSplitChart's normal descending sort, so the merged entry ranks by its total.
const MERGE_CODES = new Set(['FOB', 'IN']);
const MERGED_LABEL = 'FOB + Inclusive';

const mergeFobInclusive = (rows) => {
  let mergedValue = 0;
  let hasMerged = false;
  const rest = [];
  for (const row of rows) {
    const code = String(row.name || '').trim().toUpperCase();
    if (MERGE_CODES.has(code)) {
      mergedValue += Number(row.value) || 0;
      hasMerged = true;
    } else {
      rest.push(row);
    }
  }
  if (hasMerged) rest.push({ name: MERGED_LABEL, value: mergedValue });
  return rest;
};

const DeliveryTermsSplitChart = () => (
  <BarSplitChart
    title="Split Over Delivery Terms"
    endpoint="/dashboard/delivery-terms-split"
    cornerLabel="count"
    barColor="var(--dash-chart-5)"
    maxRows={7}
    transform={mergeFobInclusive}
    sortToggle
  />
);

export default DeliveryTermsSplitChart;
